export const b64toBlob = (b64Data: string, contentType = ''): Blob => {
  const byteCharacters = atob(b64Data);
  const byteNumbers = [];
  byteNumbers.length = byteCharacters.length;
  for (let index = 0; index < byteCharacters.length; index++) {
    byteNumbers[index] = byteCharacters.charCodeAt(index);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const byteArrays = [];
  byteArrays.push(byteArray);
  return new Blob(byteArrays, { type: contentType });
};

export const openPdf = (pdf: string) => {
  const blob = b64toBlob(pdf, 'application/pdf');
  const pdfSrc = URL.createObjectURL(blob);
  window.open(pdfSrc, '_blank');
};

export const fileXlsxDownload = (
  file: any,
  fileName: string,
  blobType: string = 'application/vnd.ms-excel'
) => {
  const blob = new Blob([file], { type: blobType });
  const filename = fileName;
  const newVariable: any = window.navigator;
  if (newVariable && newVariable.msSaveOrOpenBlob) {
    newVariable.msSaveOrOpenBlob(blob, filename);
  } else {
    let a = document.createElement('a');
    const url = URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }
};
